import {useParams} from 'react-router-dom';

import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

import {ModuleEnum, PermissionOperationEnum} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';

import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import NotificationRuleForm from '../Shared/NotificationRuleForm';
import {NotificationRuleDocumentTitle} from '../notificationRuleHelpers';

export const EditNotificationRulePage = () => {
  useSetDocumentTitle(NotificationRuleDocumentTitle);
  const {id} = useParams();

  return (
    <ContentWrapper>
      {id !== undefined && <NotificationRuleForm id={Number(id)} mode="edit" />}
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.NotificationRuleEdit(':id'),
  element: <EditNotificationRulePage />,
  module: ModuleEnum.NotificationRules,
  operation: PermissionOperationEnum.Update,
  isPrivate: true,
});

export default EditNotificationRulePage;
